import gql from 'graphql-tag';

export const NAME = 'compositions_TechAdmin_dealerInfoQuery';

export default gql`
  query ${NAME} ($id: ID!) {
    dealer (id: $id) {
      id
      name
      billTo
      shipTo
      displayAddress {
        city
        postalCode
        province
        streetAddress
      }
      phone
      fax
      storeManagerEmail
      timezone
      rotationsEmailSnoozed
      rotationsEmailSnoozedAt
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerDetails/StoreInfo/withDealerInfo/dealerInfoQuery.js